// Actions
import { permissionsRequest, permissionsSuccess, permissionsError, deviceListUpdate } from 'REDUCERS/appSlice';
import { start, end, error, success } from 'REDUCERS/browserSlice';

// Utils
import browserCheck from 'CHECKS/browser/browserCheck';
import { stopStream } from 'UTILS/stream';
import { onUnhandledError } from 'UTILS/callbacks';

export default store => next => async action => {
  switch (action.type) {
    case start.toString(): {
      next(action);
      const isBrowserSupported = browserCheck.start({
        onError: (type, payload) => store.dispatch(error({ type, data: payload })),
        onSuccess: (type, payload) => store.dispatch(success({ type, data: payload })),
      });
      if (isBrowserSupported) {
        return store.dispatch(permissionsRequest());
      } else {
        return store.dispatch(end());
      }
    }
    case permissionsRequest.toString(): {
      next(action);
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        stopStream(stream);
        return store.dispatch(permissionsSuccess());
      } catch (err) {
        if (err.name !== 'NotAllowedError') {
          return store.dispatch(permissionsSuccess());
        }
        return store.dispatch(permissionsError());
      }
    }
    case permissionsError.toString(): {
      next(action);
      store.dispatch(error({ type: 'permissions_not_given' }));
      return store.dispatch(end());
    }
    case permissionsSuccess.toString(): {
      next(action);
      const updateDeviceList = async() => {
        if (typeof !navigator?.mediaDevices?.enumerateDevices === 'function') {
          return store.dispatch(error({ type: 'browser_not_meeting_requirements' }));
        }
        try {
          // Convert into plain object to make serialization possible
          const deviceList = (await navigator.mediaDevices.enumerateDevices()).map(({ deviceId, label, kind }) => ({ deviceId, label, kind }));
          return store.dispatch(deviceListUpdate({ deviceList }));
        } catch (err) {
          onUnhandledError(err);
          return store.dispatch(error({ type: 'enumerate_devices_not_working', data: { error: err } }));
        }
      };
      navigator.mediaDevices.addEventListener('devicechange', updateDeviceList);
      await updateDeviceList();
      store.dispatch(end());
      return;
    }
    default:
      return next(action);
  }
};
